var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab_my",
    clipPath: "url(#clip0_2044_1047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1292 19.3C14.7316 19.3 18.4626 15.569 18.4626 10.9666C18.4626 6.36426 14.7316 2.6333 10.1292 2.6333C5.52686 2.6333 1.7959 6.36426 1.7959 10.9666C1.7959 15.569 5.52686 19.3 10.1292 19.3Z",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1292 10.55C11.2798 10.55 12.2126 9.61722 12.2126 8.46663C12.2126 7.31605 11.2798 6.3833 10.1292 6.3833C8.97865 6.3833 8.0459 7.31605 8.0459 8.46663C8.0459 9.61722 8.97865 10.55 10.1292 10.55Z",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.30518 16.9386C4.44838 14.7672 6.25501 13.0503 8.46268 13.0503H11.796C14.0008 13.0503 15.8056 14.7627 15.953 16.93",
    stroke: "#999999",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2044_1047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.129395 0.966797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyNo);
export default __webpack_public_path__ + "static/media/my-no.0290e0eca51b63fbc674ed16ae1620ec.svg";
export { ForwardRef as ReactComponent };